import { useMemo } from "react";
import { TabsContent } from "@/components/ui/tabs";
import { MeasurementLogEventDisplay } from "../MeasurementRequestDetails.types";
import { LOG_EVENT_TAB_ID } from "../MeasurementRequestDetails.values";
import { LogEventItem } from "./LogEventItem";

type LogEventsTabProps = {
  logEvents: MeasurementLogEventDisplay[];
};

export const LogEventsTab = ({ logEvents }: LogEventsTabProps) => {
  const sortedLogEvents = useMemo(
    () => [...logEvents].sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime()),
    [logEvents],
  );

  return (
    <TabsContent value={LOG_EVENT_TAB_ID} className="flex-1 overflow-y-scroll max-h-[45vh]">
      {sortedLogEvents.length > 0 ? (
        <div className="space-y-3">
          {sortedLogEvents.map((event) => (
            <LogEventItem key={`${event.measurementId}-${event.id}`} event={event} />
          ))}
        </div>
      ) : (
        <div className="py-8 text-center text-sm text-gray-500">No log events.</div>
      )}
    </TabsContent>
  );
};
